<template>
    <nav class="tabs">
        <ul>
            <li v-for="title in titles" :key="title" :class="{ on: title == value }">
                <v-btn @click="$emit('input', title)" text height="4rem">{{ title }}</v-btn>
            </li>
        </ul>
    </nav>
</template>

<script>
export default {
    props: ["value", "titles"],
};
</script>

<style lang="scss" scoped>
.tabs {
    ul {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: stretch;
        width: 85%;
        margin: 0 auto;
    }
    li,
    button {
        width: 100%;
        background-color: rgba(0, 0, 0, 0.02);
        font-size: 1.15rem;
        font-weight: 400;
    }
    .on {
        background: linear-gradient(to top right, #015ea2, #1ca1d5);

        button {
            color: white !important;
        }
    }
}
</style>
